if (typeof AnnouncementBar !== 'function') {

  class AnnouncementBar extends HTMLElement {

    constructor() {
      super();

      // Initialize the slider and navigation elements
      this.slider = this.querySelector('[data-js-slider]');
      this.content = this.querySelectorAll('.announcement');
      this.nextButton = this.querySelector('.announcement-bar__content-nav--right');
      this.prevButton = this.querySelector('.announcement-bar__content-nav--left');

      this.index = 0;
      this.length = this.content.length;

      // Initialize countdown clocks within the announcements
      this.countdownClocks = this.querySelectorAll('countdown-clock');
      this.initializeCountdownClocks();

      // Event listeners for navigation buttons
      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => {
          this.changeSlide('next');
        });
      }
      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => {
          this.changeSlide('prev');
        });
      }
    }

    initializeCountdownClocks() {

      // Array to hold all countdown targets
      const countdownTargets = [];

      // Loop through each countdown clock and set it up
      this.countdownClocks.forEach((clock, index) => {

        const prefixText = clock.dataset.prefixText;
        const daysEl = clock.querySelector('.days');
        const hoursEl = clock.querySelector('.hours');
        const minutesEl = clock.querySelector('.minutes');
        const secondsEl = clock.querySelector('.seconds');

        // Validate that all necessary elements exist
        if (!daysEl || !hoursEl || !minutesEl || !secondsEl) {
          console.error(`Countdown elements (.days, .hours, .minutes, .seconds) are missing in countdown clock ${index + 1}:`, clock);
          return;
        }

        // Create and insert the prefix text element if provided
        if (prefixText) {
          const prefixEl = document.createElement('span');
          prefixEl.classList.add('countdown-prefix', 'text-size--smaller');
          prefixEl.textContent = prefixText;
          clock.parentElement.insertBefore(prefixEl, clock);
        }

        // Split the date string into components
        const dateComponents = clock.dataset.date.split(',');

        // Log the raw data-date attribute

        if (dateComponents.length < 5) {
          console.error(`data-date attribute does not contain enough components (year,month,day,hour,minute) in countdown clock ${index + 1}:`, clock.dataset.date);
          // Optionally, hide the countdown or set to default values
          daysEl.innerHTML = '<span>0</span><span>0</span>';
          hoursEl.innerHTML = '<span>0</span><span>0</span>';
          minutesEl.innerHTML = '<span>0</span><span>0</span>';
          secondsEl.innerHTML = '<span>0</span><span>0</span>';
          return;
        }

        const year = parseInt(dateComponents[0], 10);
        const month = parseInt(dateComponents[1], 10) - 1; // Months are 0-based in JS
        const day = parseInt(dateComponents[2], 10);
        const hour = parseInt(dateComponents[3], 10);
        const minute = parseInt(dateComponents[4], 10) || 0; // Default to 0 if not provided

        // Validate parsed date components
        if (isNaN(year) || isNaN(month) || isNaN(day) || isNaN(hour) || isNaN(minute)) {
          console.error(`Invalid data-date format in countdown clock ${index + 1}:`, clock.dataset.date);
          // Optionally, hide the countdown or set to default values
          daysEl.innerHTML = '<span>0</span><span>0</span>';
          hoursEl.innerHTML = '<span>0</span><span>0</span>';
          minutesEl.innerHTML = '<span>0</span><span>0</span>';
          secondsEl.innerHTML = '<span>0</span><span>0</span>';
          return;
        }


        // Create the countdown date object with minutes
        const COUNT = new Date(year, month, day, hour, minute);

        // Timezone adjustment
        const gmt = parseInt(clock.dataset.timezone, 10);
        const timezone = COUNT.getTimezoneOffset() / -60; // Convert minutes to hours


        if (!isNaN(gmt) && timezone !== gmt) {
          COUNT.setHours(hour + timezone - gmt);
          // console.log(`Adjusted COUNT Date after timezone adjustment for countdown clock ${index + 1}:`, COUNT);
        } else if (isNaN(gmt)) {
          // console.error(`Invalid timezone value in countdown clock ${index + 1}:`, clock.dataset.timezone);
        } else {
          // console.log(`No timezone adjustment needed for countdown clock ${index + 1}.`);
        }

        // Add to countdown targets
        countdownTargets.push({
          COUNT,
          elements: { daysEl, hoursEl, minutesEl, secondsEl }
        });
      });

      // Function to update all countdowns
      const updateAllCountdowns = () => {
        const now = new Date().getTime();

        countdownTargets.forEach((target, idx) => {
          const distance = target.COUNT - now;

          // Calculate time components
          const days = Math.floor(distance / (1000 * 60 * 60 * 24));
          const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          const seconds = Math.floor((distance % (1000 * 60)) / 1000);

          // Log the countdown components
          // console.log(`Countdown Update for clock ${idx + 1}:`, {
          //   days,
          //   hours,
          //   minutes,
          //   seconds,
          //   distance: distance > 0 ? `${distance}ms` : 'Expired'
          // });

          // Update HTML elements with leading zeros
          target.elements.daysEl.innerHTML = days < 10
            ? `<span>0</span><span>${days}</span>`
            : days.toString().split('').map(digit => `<span>${digit}</span>`).join("");

          target.elements.hoursEl.innerHTML = hours < 10
            ? `<span>0</span><span>${hours}</span>`
            : hours.toString().split('').map(digit => `<span>${digit}</span>`).join("");

          target.elements.minutesEl.innerHTML = minutes < 10
            ? `<span>0</span><span>${minutes}</span>`
            : minutes.toString().split('').map(digit => `<span>${digit}</span>`).join("");

          target.elements.secondsEl.innerHTML = seconds < 10
            ? `<span>0</span><span>${seconds}</span>`
            : seconds.toString().split('').map(digit => `<span>${digit}</span>`).join("");

          // If countdown is finished, reset to zeros
          if (distance < 0) {
            // console.log(`Countdown expired for clock ${idx + 1}. Resetting to zeros.`);
            target.elements.daysEl.innerHTML = '<span>0</span><span>0</span>';
            target.elements.hoursEl.innerHTML = '<span>0</span><span>0</span>';
            target.elements.minutesEl.innerHTML = '<span>0</span><span>0</span>';
            target.elements.secondsEl.innerHTML = '<span>0</span><span>0</span>';
          }
        });
      };

      // Start a single interval to update all countdowns
      const interval = setInterval(updateAllCountdowns, 1000);
      updateAllCountdowns();
    }

    changeSlide(direction) {
      this.nextButton.classList.remove('announcement-bar__content-nav--disabled');
      this.prevButton.classList.remove('announcement-bar__content-nav--disabled');

      if (direction === 'next') {
        this.index++;
      } else if (direction === 'prev') {
        this.index--;
      }

      if (this.index === this.length - 1) {
        this.nextButton.classList.add('announcement-bar__content-nav--disabled');
      } else if (this.index === 0) {
        this.prevButton.classList.add('announcement-bar__content-nav--disabled');
      }

      this.slider.scrollTo({
        top: 0,
        left: this.content[this.index].offsetLeft,
        behavior: 'smooth'
      });
    }

  }

  if (typeof customElements.get('announcement-bar') === 'undefined') {
    customElements.define('announcement-bar', AnnouncementBar);
  }

}